<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout justify-center>
        <v-flex xs12 sm10 md8 lg6>
          <v-card>
            <v-card-title><h1>Administration</h1></v-card-title>
            <v-card-text>
              <!-- <v-btn color="primary" @click="moveStudentData">Move Student Data</v-btn>
              <v-btn color="primary" @click="deleteStudentData">Delete Student Data</v-btn> -->
            </v-card-text>
            <!-- <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn flat>Cancel</v-btn>
              <v-spacer></v-spacer>
            
              <v-btn color="primary" flat @click="submit">Submit</v-btn>
            </v-card-actions> -->
          </v-card>
          <v-card >
            <v-card-title>Yearly Update Process</v-card-title>
            <v-card-text>
            Upload CSV file for students for the new school year and update existing data:
              <v-file-input
                accept="text/csv"
                label="Students CSV File"
                v-model="yearly_file"
              ></v-file-input>
              <v-text-field
                v-model="yearly_year"
                label="Previous Year"
              ></v-text-field>
              <v-btn
                :loading="yearly_submitting"
                :disabled="yearly_submitting"
                color="primary" @click="postYearlyUpdateFile">Do Yearly Process</v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
     <v-snackbar
      v-model="snackbar"
      :color="snackbarType"
      :timeout="snackbarTimeout"
      top
    >
      {{ snackbarMessage }}
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import firebase from 'firebase';

const axios = require('axios');

export default {
  name: 'Admin',
  data () {
    return {
      yearly_year:'',
      yearly_file:'',
      yearly_submitting:false,
      snackbar:false,
      snackbarMessage:'',
      snackbarType:'error',
      snackbarTimeout: 10000
    }
  },
  methods: {
    postYearlyUpdateFile() {
      this.yearly_submitting = true;
      console.log('[postYearlyUpdateFile] ', this.yearly_year, this.yearly_file);
      const formData = new FormData();
      formData.append('year', this.yearly_year);
      formData.append('student_file', this.yearly_file);
      axios
      .post(process.env.VUE_APP_YEARLY_UPDATE_ENDPOINT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        this.yearly_submitting = false;
        this.snackbarType = 'success';
        this.snackbarTimeout = 10000;
        this.snackbarMessage = 'Yearly switchover process completed! Check the student list to verify.'
        this.snackbar = true;
      })
      .catch((err) => {
        this.yearly_submitting = false;
        this.snackbarTimeout = 0;
        this.snackbarMessage = err.message;
        this.snackbarType = 'error';
        this.snackbar = true;
      });
    },
    moveStudentData() {
      firebase.firestore().collection('students').get().then((snapshot) => {
        snapshot.forEach((doc) => {
          console.log(doc.data());
          let student = doc.data();
          firebase.firestore().collection('students_2018').add(student).then((ref) => {
              console.log('Added new student:', ref.id);           
            });
        });
      });
    },
    deleteStudentData() {
      firebase.firestore().collection('students').get().then((snapshot) => {
        snapshot.forEach((doc) => {
          //console.log(doc.data());
          //doc.delete();
          firebase.firestore().collection('students').doc(doc.id).delete();
        });
      });
    }
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
